export default class accordion {
    constructor(){

        this.$target;

        this.status = {
            open : []
        }

        this.deviceSize;

    }
    init(scroll){

        this.$target = document.querySelectorAll(".js__tab-sp-trigger");

        for(let i in this.$target){

            if(this.$target[i].nodeType!=1) continue; // dom要素以外は処理止める

            this.status.open[i] = false;
            if(window.innerWidth<=750) TweenLite.set(this.$target[i].nextElementSibling.querySelectorAll("li"),{opacity:0,y:30});

            this.$target[i].addEventListener("click",(e)=>{

                this.mot(i,e.target,e.target.nextElementSibling,scroll);

            });

        }


    }
    mot(i,$t,$b,scroll){



        if(!this.status.open[i]){
            this.status.open[i] = true;
            $t.classList.add("is-current");
            TweenMax.to($b,0.8,{
                height : $b.children[0].clientHeight,
                ease: Power2.easeOut,
                onComplete:()=>{
                    scroll.resize();
                }
            })
            TweenMax.staggerTo($b.querySelectorAll("li"),0.8,{
                opacity:1,
                y:0,
            },0.1);

        }else{
            this.status.open[i] = false;
            $t.classList.remove("is-current");
            TweenMax.staggerTo($b.querySelectorAll("li"),0.4,{
                opacity:0,
                y:30,
            },0.05,()=>{

            });

            TweenMax.to($b,0.6,{
                height : 0,
                ease: Power2.easeOut,
                onComplete:()=>{
                    scroll.resize();
                }
            })
        }


    }
    resize(deviceSize){

        if(deviceSize !== this.deviceSize){
            this.deviceSize = deviceSize;
            if(deviceSize!="sp"){

                for(let i in this.$target){

                    if(this.$target[i].nodeType!=1) continue; // dom要素以外は処理止める

                    this.status.open[i] = false;
                    if(Number(i) === 0) {
                        this.$target[i].classList.add("is-current");
                    }
                    //this.$target[i].nextElementSibling.style = "";
                    TweenLite.set(this.$target[i].nextElementSibling,{ css:{height: 'initial'}});
                    TweenLite.set(this.$target[i].nextElementSibling.querySelectorAll("li"),{opacity:1,y:0});

                }

            }else{
                for(let i in this.$target){

                    if(this.$target[i].nodeType!=1) continue; // dom要素以外は処理止める
                    if(Number(i) === 0){
                        this.$target[i].classList.add("is-current");
                        TweenLite.set(this.$target[i].nextElementSibling,{ css:{height: this.$target[i].nextElementSibling.children[0].clientHeight}});
                        TweenLite.set(this.$target[i].nextElementSibling.querySelectorAll("li"),{opacity:1,y:0});
                    }else{
                        TweenLite.set(this.$target[i].nextElementSibling.querySelectorAll("li"),{opacity:0,y:30});
                    }
                }

            }
        }
    }
}
